const initialState = [
  {
    id: 1,
    title: "Make task manager",
    steps: [
      { step: "Find design", completed: true },
      { step: "Implement styles", completed: true },
      { step: "Add components", completed: true },
      { step: "Create state", completed: true },
      { step: "Make reducer", completed: true },
      { step: "Apply events", completed: true },
      { step: "Enjoy result", completed: false },
    ],
  },
];

export default initialState;
